import useTags from '@/utils/useTags'
import React from 'react'
import Dropdown from '@/components/Dropdown'
import { Tag } from 'react-feather'

export default function VideosTagsFilter({
  className,
  selectedTags,
  setSelectedTags,
}) {
  const [tags] = useTags()
  const selected = selectedTags.length ? selectedTags[0] : 'all-tags'

  function handleMenuClick(newTag) {
    if (newTag === 'all-tags') {
      setSelectedTags([])
    } else {
      setSelectedTags([newTag])
    }
  }

  const options = [
    {
      name: 'All Tags',
      value: 'all-tags',
      selected: selected === 'all-tags',
      icon: (
        <Tag className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
      ),
    },
    ...tags.map((tag) => ({
      name: tag.label,
      value: tag.value,
      selected: selected === tag.value,
      icon: (
        <Tag className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
      ),
    })),
  ]

  return (
    <Dropdown
      options={options}
      position="left"
      className={className}
      onChange={handleMenuClick}
      selected={selected}
    />
  )
}

// export default function VideosTagsFilter({
//   className,
//   selectedTags,
//   setSelectedTags,
// }) {
//   const [options] = useTags()

//   return (
//     <Select
//       className={`react-select ${className}`}
//       defaultValue={selectedTags}
//       options={options}
//       tabIndex="-1"
//       noOptionsMessage={() => <span>No Tags</span>}
//       placeholder="Select Tag"
//       isMulti
//       isSearchable
//       onChange={(updatedTags) => {
//         analytics.track('Change tag filter')
//         setSelectedTags(updatedTags)
//       }}
//     />
//   )
// }
